import { ReactNode } from "react";

export type WithChildren = {
  children?: ReactNode;
};

export const truncateText = (text: string, len: number = 50) => {
  return text.length > len ? text.substring(0, len - 3) + "..." : text;
};

export const preloadImages = (srcs: string[]): Promise<void[]> => {
  return Promise.all(
    srcs.map((src) => {
      return new Promise<void>((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve();
        img.onerror = () => reject(new Error(`Failed to preload image ${src}`));
      });
    })
  );
};
